import { fhirClients } from "src-next/shared/api/fhirClient";
import { extractResourcesFromBundle } from "../../statistics/helpers/crmMessageFranchiseStatsHelpers";
import {
  FLUXZAP_BASIC_NOTIFICATION_IDENTIFIER_SYSTEM,
  FLUXZAP_BASIC_NOTIFICATION_IDENTIFIER_VALUE,
} from "../constants/clinicalCrmCommunicationsFhirConstants";
import {
  buildFluxZapOrganizationReference,
  isFluxZapBasicForOrganization,
  mapFhirBasicsToFluxZapCommunicationRecords,
} from "../helpers/mapFhirBasicToFluxZapCommunicationRecord";
import type { FluxZapCommunicationRecord } from "../types";

async function fetchFluxZapCommunicationsByOrganization(
  organizationId: string,
): Promise<FluxZapCommunicationRecord[]> {
  const trimmed = organizationId?.trim();
  if (!trimmed) return [];

  const organizationReference = buildFluxZapOrganizationReference(trimmed);
  const fluxzapToken = `${FLUXZAP_BASIC_NOTIFICATION_IDENTIFIER_SYSTEM}|${FLUXZAP_BASIC_NOTIFICATION_IDENTIFIER_VALUE}`;

  try {
    const bundle = await fhirClients.admin.search<fhir5.Basic>("Basic", {
      identifier: fluxzapToken,
      _sort: "-created",
      _count: "5000",
    });

    const basics = extractResourcesFromBundle<fhir5.Basic>(bundle).filter(
      (basic) => isFluxZapBasicForOrganization(basic, organizationReference),
    );
    return mapFhirBasicsToFluxZapCommunicationRecords(basics);
  } catch (err) {
    console.warn("clinicalCrmFluxZapBasicService.fetch", err);
    return [];
  }
}

export const clinicalCrmFluxZapBasicService = {
  fetchFluxZapCommunicationsByOrganization,
};
